export const removeTrailingSlash = (url: string): string => {
  if (url.endsWith("/")) {
    const newUrl = url.slice(0, -1);
    return removeTrailingSlash(newUrl);
  }
  return url;
};
